import { format, subMonths } from 'date-fns';
import { z } from 'zod/v4';

import { getLatestSelectableDate } from '@/shared/utils/date';

const getOneMonthAgo = () => subMonths(getLatestSelectableDate(), 1);

export const DashboardFiltersSchema = z
  .object({
    dateFrom: z.iso
      .date()
      .default(() => format(getOneMonthAgo(), 'yyyy-MM-dd'))
      .catch(() => format(getOneMonthAgo(), 'yyyy-MM-dd')),
    dateTo: z.iso
      .date()
      .default(() => format(getLatestSelectableDate(), 'yyyy-MM-dd'))
      .catch(() => format(getLatestSelectableDate(), 'yyyy-MM-dd')),
  })
  .transform((data) => {
    const fromDate = new Date(data.dateFrom);
    const toDate = new Date(data.dateTo);

    // If dateFrom is greater than dateTo, swap them
    if (fromDate > toDate) {
      return {
        dateFrom: data.dateTo,
        dateTo: data.dateFrom,
      };
    }

    return data;
  });

export type DashboardFilters = z.infer<typeof DashboardFiltersSchema>;
